/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */
'use strict';

/**
 * Directive to allow hooking up to the 'input' in the same way as other ng event directives such as ng-keyup,
 * ng-keypress, etc.
 *
 * See 'ngEventDirectives' in the angular code for the original implementation of those other directives.
 */
angular.module('bulbApp.utilsModule')

.directive('ngInput', ['$parse', ngInput]);

function ngInput($parse) {
  return {
    restrict: 'A',
    compile: function($element, attr) {
      // We expose the powerful $event object on the scope that provides access to the Window,
      // etc. that isn't protected by the fast paths in $parse.  We explicitly request better
      // checks at the cost of speed since event handler expressions are not executed as
      // frequently as regular change detection.
      var fn = $parse(attr.ngInput, /* interceptorFn */ null, /* expensiveChecks */ true);
      return function ngEventHandler(scope, element) {
        element.on('input', function(event) {
          var callback = function() {
            fn(scope, {$event:event});
          };
          scope.$apply(callback);
        });
      };
    }
  };
}
